//npm packages
import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { DropdownItem } from 'reactstrap';

//redux
import { logout, login, applicationSetting } from '../../../redux/actions';

//helper
import strings from '../../../globalization';

export default () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const onLogout = () => {
    dispatch(logout());
  };
  const logoutData = useSelector(state => state.logoutData.data, shallowEqual);
  useEffect(() => {
    if (logoutData.success) {
      dispatch(login(null, { type: 'LOGIN_RESET' }));
      dispatch(logout(null, { type: 'LOGOUT_RESET' }));
      dispatch(applicationSetting({ selectedMenu: '' }));
      history.push({ pathname: '/' });
    }
  }, [logoutData, dispatch, history]);

  return (
    <DropdownItem onClick={onLogout}>
      <FontAwesomeIcon
        size="lg"
        title={strings.LogOut}
        icon={faSignOutAlt}
        className={'mr-2 headerIcon'}
      />
      {strings.LogOut}
    </DropdownItem>
  );
};
